// Parses MySQL "YYYY-MM-DD HH:MM:SS" strings as UTC
export function parseUtc(d: string): Date {
  return new Date(d.length === 19 && d.includes(' ') ? d.replace(' ', 'T') + 'Z' : d);
}

// DD/MM/YYYY — for date-only fields (no timezone conversion needed)
export function formatDate(d: string | null | undefined): string {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// DD/MM/YYYY HH:MM — for UTC datetime fields displayed in a given timezone
export function formatDatetime(d: string | null | undefined, tz = 'Europe/Copenhagen'): string {
  if (!d) return '—';
  return parseUtc(d).toLocaleString('da-DK', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZone: tz,
  });
}

// HH:MM — time only
export function formatTime(d: string | null | undefined, tz = 'Europe/Copenhagen'): string {
  if (!d) return '—';
  return parseUtc(d).toLocaleString('da-DK', { hour: '2-digit', minute: '2-digit', timeZone: tz });
}
